import React, { useEffect, useState, useRef } from 'react';

import clsx from 'clsx';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import { Card, Icon } from '@material-ui/core';
import { colors } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { mainListItems, SecondaryListItems } from '../listItems';
import { useSelector, useDispatch } from "react-redux"
import { Button } from '@material-ui/core';
import logo5 from "../../logo5.png"
import RehabPlanMainComponent from '../data/overview_data.js/RehabPlanMainComponent'
import Treatmentadvices from '../data/treatmentadvice/Treatmentadvice.js';
import recoveryPhases from '../../user_dashboard/data/recoveryPhases';
import * as AuthActions from "../../../store/actions/auth";
import ReactPlayer from 'react-player'
import RehabPhases from "../data/rehabPhases.js";
import HorizontalScroll from 'react-horizontal-scrolling'
import Skeleton from '@material-ui/lab/Skeleton';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import LinearWithValueLabel from './LinearProgressWithLabel';
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import CustomizedProgressBars from './ProgressBar2';
import FastRewindIcon from '@material-ui/icons/FastRewind';
import FastForwardIcon from '@material-ui/icons/FastForward';
import Slider from "@material-ui/core/Slider";
import Tooltip from "@material-ui/core/Tooltip";
import Popover from '@material-ui/core/Popover';
import TreatmentSessionPlayer from './treatmentSessionPlayer';
import Duration from './VideoDurationTimer';
import { withStyles } from "@material-ui/core/styles"
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { green } from '@material-ui/core/colors';

const styles = (theme) => ({
    root: {
      flexGrow: 1,
      padding: theme.spacing(0),
    },
    // overlay for next exercise thumbnails
    thumbsOverlay: {
      position: 'relative',
      top: 40,
      left: '1%',
      zIndex: 2,
      background: 'blue',
      borderRadius: 8,
      padding: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
      maxHeight: '65vh',
      overflowY: 'auto',
      gap: 4,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      // responsive padding/position
      [theme.breakpoints.up('lg')]: {
        padding: 10,
        left: '1%'
      },
      [theme.breakpoints.down('sm')]: {
        padding: 6,
        top: 48,
        left: '0.5%'
      }
    },
    // individual thumbnail item
    thumbItem: {
      position: 'relative',
      minWidth: 24,
      maxWidth: 24,
      height: 24,
      borderRadius: 6,
      overflow: 'hidden',
      boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
      opacity: 1,
      border: '2px solid rgba(210,215,224,1)',
      marginBottom: 0,
      [theme.breakpoints.up('md')]: {
        minWidth: 28,
        maxWidth: 28,
        height: 28,
        borderRadius: 6
      },
      [theme.breakpoints.up('lg')]: {
        minWidth: 32,
        maxWidth: 32,
        height: 32
      },
      [theme.breakpoints.up('xl')]: {
        minWidth: 36,
        maxWidth: 36,
        height: 36
      }
    },
    thumbImg: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block'
    },
    responsive: {
      width: "100%",
      height: "auto",
    },
    ActionButton2: {
        background: '#002D55',
        color: '#fb741aff',
        border: 'none',
        minWidth: 200,
        fontWeight: 600,
        fontSize: 'clamp(12px, 1vw, 16px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px 2px 11px 2px',
        borderRadius: 6,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        transition: 'background 0.2s',
      "&:hover": {
            boxShadow: "none",
            backgroundColor: "#0062cc",
            borderColor: "#0062cc"
          },
    },
    titleText: {
    color: '#002D55',
    fontWeight: 800,
    marginBottom: 4,
    marginTop: 0,
    textAlign: 'left',
    letterSpacing: 0.04,
    fontSize: 'clamp(1.1rem, 2vw, 1.5rem)',
    [theme.breakpoints.up('xl')]: { fontSize: '1.0rem', marginTop: 5, marginLeft: 60 },
    [theme.breakpoints.down('lg')]: { fontSize: '0.9rem', marginTop: 5, marginLeft: 55 },
    [theme.breakpoints.down('md')]: { fontSize: '0.8rem', marginTop: 5, marginLeft: 40 },
    [theme.breakpoints.down('sm')]: { fontSize: '0.75rem', marginTop: 5, marginLeft: 35 },
    [theme.breakpoints.down('xs')]: { fontSize: '0.7rem', marginTop: 6, marginLeft: 35 }
  },
  // responsive center play button
  iconButtonCenter: {
    color: '#fff',
    margin: 15,
    background: 'rgba(0,45,85,0.18)',
    borderRadius: 32,
    boxShadow: '0 2px 8px rgba(0,45,85,0.10)',
    transition: 'background 0.2s',
    width: 64,
    height: 64,
    fontSize: 'clamp(24px, 2.5vw, 40px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      fontSize: 'inherit'
    },
    [theme.breakpoints.down('sm')]: {
      width: 48,
      height: 48,
      margin: 10
    },
    [theme.breakpoints.up('lg')]: {
      width: 80,
      height: 80,
    }
  },
  // responsive small icon buttons (bottom controls)
  styledIconResponsive: {
    minWidth: 40,
    minHeight: 40,
    width: 40,
    height: 40,
    fontSize: 'clamp(16px, 1.5vw, 24px)',
    [theme.breakpoints.down('sm')]: {
      minWidth: 32,
      minHeight: 32,
      width: 32,
      height: 32,
    },
    [theme.breakpoints.up('lg')]: {
      minWidth: 48,
      minHeight: 48,
      width: 48,
      height: 48,
    },
    '& svg': {
      fontSize: 'inherit'
    }
  },
  });

  // Fallback thumbnail styles for class component usage. We'll compute sizes at render time.
  // Converted to runtime helpers so we can compute responsive values using window width
  // (no `theme` available here).
  const thumbnailStyles = {
    overlay: (vw = 1024) => {
      // derive responsive values similar to previous breakpoints
      let fontSize = 'clamp(1.1rem, 2vw, 1.5rem)';
      let marginTop = 0;
      let marginLeft = 0;
      if (vw >= 1920) {
        fontSize = '1.0rem';
        marginTop = 14;
        marginLeft = 0;
      } else if (vw >= 1280) {
        fontSize = '0.9rem';
        marginTop = 10;
        marginLeft = 0;
      } else if (vw >= 960) {
        fontSize = '0.8rem';
        marginTop = 8;
        marginLeft = 0;
      } else if (vw >= 600) {
        fontSize = '0.75rem';
        marginTop = 8;
        marginLeft = 0;
      } else {
        fontSize = '0.7rem';
        marginTop = 4;
        marginLeft = 0;
      }
      return {
        position: 'absolute',
        top: marginTop,
        left: '1%',
        zIndex: 2,
        background: 'transparent',
        borderRadius: 8,
        padding: '0.5%',
        boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
        maxHeight: '65vh',
        overflowY: 'auto',
        gap: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        fontSize,
        marginLeft
      };
    },
    item: (size) => ({
      position: 'relative',
      minWidth: size,
      maxWidth: size,
      height: size,
      borderRadius: 6,
      overflow: 'hidden'
    }),
    img: (size) => ({
      width: size,
      height: size,
      objectFit: 'cover',
      display: 'block'
    }),
  };

  const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    '&$checked': {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

  const ActionButton1 = withStyles({
    root: {
        backgroundColor: '#e6eaf0',
        color: '#002D55',
        border: 'none',
        fontWeight: 600,
        fontSize: 'clamp(11px, 0.9vw, 14px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2px 8px 0px 8px',
        borderRadius: 4,
        borderBottom: '0.5px solid #002D55',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        transition: 'background 0.2s',
      "&:hover": {
            backgroundColor: '#e6eaf0', // light grey that fits the theme
      color: 'orange',
      fontWeight: 'bold',
            borderRadius: 4
          },
    },
    })(Button);

  const ActionButton2 = withStyles({
    root: {
        boxShadow: "none",
        textTransform: "none",
        fontSize: 'clamp(11px, 1.4vw, 20px)',
        padding: "0px 0px",
        border: "0.5px solid",
        lineHeight: 0.5,
        backgroundColor: "#002D55",
        borderColor: "#002D55",
        color: "#FFFFFF",
        fontFamily: [
          "-apple-system",
          "BlinkMacSystemFont",
          '"Segoe UI"',
          "Roboto",
          '"Helvetica Neue"',
          "Arial",
          "sans-serif",
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"'
        ].join(","),
        "&:hover": {
            boxShadow: "none",
            backgroundColor: "#0062cc",
            borderColor: "#0062cc"
          },
        //"&:active": {
        //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
        //  backgroundColor: "#002D55",
        //  borderColor: "#002D55"
        //},
        //"&:focus": {
        //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
        //}
      }
    })(Button);

  const StyledIconButton = withStyles({
    root: {
        margin: 0,
        background: '#002D55',
        color: '#ff9800',
        border: 'none',
        minWidth: 40,
        minHeight: 40,
        width: 40,
        height: 40,
        fontWeight: 600,
        fontSize: 'clamp(11px, 1.4vw, 20px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        borderRadius: 24,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        transition: 'background 0.2s',
      "&:hover": {
            backgroundColor: '#e6eaf0', // light grey that fits the theme
      color: '#ff9800',
      fontWeight: 'bold',
          },
      //"&:active": {
      //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
      //  backgroundColor: "#002D55",
      //  borderColor: "#002D55"
      //},
      //"&:focus": {
      //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
      //}
    }
  })(Button);

class VideoPlayer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            timeDisplayFormat: "normal",
            //isPlaying: props.isPlaying,
            isFullScreen: false ,
            playingData: {
                duration: 0,
                played: 0,
                playedSeconds: 0
            }

      ,
      // responsive thumbnail size (px)
      thumbSize: 48

      // visible next exercises for frontend-only countdown tracker
      , visibleNextExercises: Array.isArray(props.nextExercises) ? props.nextExercises.filter(e => !e.completed) : []

        }
        this.className = props.className
        this.playerContainerRef = React.createRef();
        this.playerRef = React.createRef();
    }

    componentDidMount() {
      // set initial thumb size and attach resize listener
      this.updateThumbSize();
      // ensure visibleNextExercises is synced on mount (in case props arrived after ctor)
      if (Array.isArray(this.props.nextExercises)) {
        this.setState({ visibleNextExercises: this.props.nextExercises.filter(e => !e.completed) });
      }
      if (typeof window !== 'undefined') {
        this._boundResize = this.updateThumbSize.bind(this);
        window.addEventListener('resize', this._boundResize);
      }
    }

    componentDidUpdate(prevProps) {
      // If the parent updated the nextExercises list, sync the visible list but keep it frontend-only
      if (prevProps.nextExercises !== this.props.nextExercises) {
        const incoming = Array.isArray(this.props.nextExercises) ? this.props.nextExercises : [];
        const newVisible = incoming.filter(e => !e.completed);
        // Include media fields so live external exercise hydration refreshes its thumbnail.
        const same = (arrA, arrB) => {
          if (arrA.length !== arrB.length) return false;
          for (let i = 0; i < arrA.length; i++) {
            const a = arrA[i]; const b = arrB[i];
            if (
              !a || !b
              || (a.id || a.identifier || a.title) !== (b.id || b.identifier || b.title)
              || a.title !== b.title
              || a.img !== b.img
              || a.video !== b.video
              || a.completed !== b.completed
            ) return false;
          }
          return true;
        };
        if (!same(newVisible, this.state.visibleNextExercises)) {
          this.setState({ visibleNextExercises: newVisible });
        }
      }
    }

    componentWillUnmount() {
      if (typeof window !== 'undefined' && this._boundResize) {
        window.removeEventListener('resize', this._boundResize);
      }
    }

    updateThumbSize() {
      if (typeof window === 'undefined') return;
      const vw = window.innerWidth;
      let thumbSize = 48;
      if (vw >= 1920) thumbSize = 64; // xl
      else if (vw >= 1280) thumbSize = 56; // lg
      else if (vw >= 960) thumbSize = 48; // md
      else if (vw >= 600) thumbSize = 40; // sm
      else thumbSize = 32; // xs
      if (this.state.thumbSize !== thumbSize) {
        this.setState({ thumbSize });
      }
    }

    //const [state, setState] = useState({
    //    volume: 0.5,
    //    duration: 0,
    //    played: 0,
    //    playedSeconds: 0
    //});
    
    handleDuration = (duration) => {
        //console.log('onDuration', duration)
        this.setState(oldState => {
            return {
                ...oldState, playingData: {
                    ...oldState.playingData,
                    duration: duration
                }
            }
        })
    };
    
    //componentDidUpdate(prevProps) {
    //    if (prevProps.isPlaying !== this.props.isPlaying) {
    //        this.setState({ isPlaying: this.props.isPlaying });
    //    }
    //}

    handleProgress = playingData => {
        //console.log('onProgress', state)
        // We only want to update time slider if we are not currently seeking
        this.setState(oldState => { return { ...oldState, playingData: playingData } })

    };

    //resumePlaying = () => {
    //    this.setState(oldState => { return { ...oldState, isPlaying: true } })
    //}
//
    //pausePlaying = () => {
    //    this.setState(oldState => ({ ...oldState, isPlaying: false }));
    //}

    format = (seconds) => {
        if (isNaN(seconds)) {
            return `00:00`;
        }
        const date = new Date(seconds * 1000);
        const hh = date.getUTCHours();
        const mm = date.getUTCMinutes();
        const ss = date.getUTCSeconds().toString().padStart(2, "0");
        if (hh) {
            return `${hh}:${mm.toString().padStart(2, "0")}:${ss}`;
        }
        return `${mm}:${ss}`;
    };

    restart = () => {
      // Changing the exercise URL resets ReactPlayer itself. Seeking here can
      // target an unmounted internal player while the next source is loading.
      this.setState({
        playingData: {
          duration: 0,
          played: 0,
          playedSeconds: 0,
        },
      });
    };



  render() {
    const { exercise, classes } = this.props;
      // compute thumbnail size based on viewport width
      const vw = typeof window !== 'undefined' ? window.innerWidth : 1024;
      let thumbSize = 32;
      if (vw >= 1920) thumbSize = 48; // xl
      else if (vw >= 1280) thumbSize = 40; // lg
      else if (vw >= 960) thumbSize = 32; // md
      else thumbSize = 28; // sm/xs
            if (!exercise) {
        // Optionally render a loading spinner or placeholder
                return (
                <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(to bottom, #000, #333)' }}>
                    <Typography variant="h6" color="#fff">
                        No exercise loaded.
                    </Typography>
                </div>
            );
        }
        return (
            <div
                ref={this.playerContainerRef}
        style={{
          width: '100%',
          height: '100%',
          borderRadius: 18,
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'center',
          minHeight: 0,
          marginTop: 0,
          margin: 0,
          background: 'linear-gradient(to bottom, #000, #333)',
        }}
            >
                    <ReactPlayer
                      key={`${this.props.exercise?.identifier || this.props.exercise?.id || 'exercise'}-${this.props.exercise?.video || ''}`}
                        ref={this.playerRef}
                        width={"100%"}
                        height={"100%"}
                        url={this.props.exercise ? this.props.exercise.video : null}
                        playing={this.props.isPlaying}
                        fullScreen={this.state.isFullScreen}
                        controls={false}
                        onEnded={this.props.goToFeedback}
                        volume={1}
                        onProgress={this.handleProgress}
                        progressInterval={50}
                    />
                        {/* Overlay for next exercises thumbnails */}
                        {Array.isArray(this.state.visibleNextExercises) && this.state.visibleNextExercises.length > 0 && (
                          <Box style={{ ...thumbnailStyles.overlay(vw), left: '1%', zIndex: 2 }}>
                            {this.state.visibleNextExercises.map((exercise, idx) => {
                              // determine if this thumbnail corresponds to the current exercise
                              const current = this.props.exercise || {};
                              const curKey = current.id || current.title || current.video || null;
                              const exKey = exercise.id || exercise.title || exercise.video || null;
                              const isCurrent = curKey && exKey && curKey === exKey;
                                return (
                                <Box key={idx} style={{ ...thumbnailStyles.item(thumbSize), borderRadius: 10, boxShadow: '0 1px 4px rgba(0,0,0,0.10)', overflow: 'hidden', position: 'relative', marginBottom: 2 }}>
                                  {exercise.img ? (
                                    <>
                                      <img
                                        alt={exercise.title}
                                        src={exercise.img}
                                        style={thumbnailStyles.img(thumbSize)}
                                        onError={(event) => {
                                          event.currentTarget.style.display = 'none';
                                          event.currentTarget.nextElementSibling.style.display = 'flex';
                                        }}
                                      />
                                      <Box
                                        style={{
                                          ...thumbnailStyles.img(thumbSize),
                                          display: 'none',
                                          background: '#e6eaf0',
                                          color: '#002D55',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          padding: 3,
                                          boxSizing: 'border-box',
                                          fontSize: Math.max(8, Math.floor(thumbSize / 4)),
                                          fontWeight: 700,
                                          lineHeight: 1,
                                          textAlign: 'center',
                                        }}
                                      >
                                        {(exercise.title || '?').slice(0, 2).toUpperCase()}
                                      </Box>
                                      {/* semi-transparent grey overlay for non-current thumbnails */}
                                      {!isCurrent && (
                                        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(128,128,128,0.45)', pointerEvents: 'none' }} />
                                      )}
                                    </>
                                  ) : (
                                    <Box
                                      style={{
                                        ...thumbnailStyles.img(thumbSize),
                                        background: '#e6eaf0',
                                        color: '#002D55',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: 3,
                                        boxSizing: 'border-box',
                                        fontSize: Math.max(8, Math.floor(thumbSize / 4)),
                                        fontWeight: 700,
                                        lineHeight: 1,
                                        textAlign: 'center',
                                        overflow: 'hidden',
                                      }}
                                    >
                                      {(exercise.title || '?').slice(0, 2).toUpperCase()}
                                    </Box>
                                  )}
                                </Box>
                              );
                            })}
                          </Box>
                        )}
                    <div style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: "rgba(0,0,0,0.0)",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        zIndex: 1,
                    }}>
                        {/* Top bar: title and actions */}
                        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between" style={{ width: "100%", padding: "clamp(0.7%, 1.125%, 1.5%) clamp(0.8%, 1.4%, 2%) 0 clamp(0.8%, 1.4%, 2%)", background: "rgba(0,0,0,0)", borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
                            <Box display="flex" flexDirection="column" alignItems="flex-start" style={{ flex: 1, minWidth: 0, paddingRight: 0 }}>
                                <Typography variant="h6" className={classes.titleText} style={{
                                        background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)',
                                        color: '#002D55',
                                        border: 'none',
                                        fontWeight: 600,
                                        left: "1%",
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '2px 10px 0px 10px',
                                        borderRadius: 14,
                                        transition: 'background 0.2s',
                                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
                                    }}>
                                    {this.props.exercise.title}
                                </Typography>
                            </Box>
                            {/*<Box display="flex" flexDirection="row" alignItems="center" style={{ minWidth: 0, marginRight: 5 }}>
                                <ActionButton1
                                    onClick={e => {
                                        this.props.goToEducation(e);
                                        if (this.props.onPlayPauseClick && this.props.isPlaying) {
                                            this.props.onPlayPauseClick();
                                        }
                                    }}
                                    aria-label="education"
                                    
                                >
                                    Explain
                                </ActionButton1>
                            </Box>
                            <Box display="flex" flexDirection="row" alignItems="center">
                                <ActionButton1
                                    onClick={this.props.goToFeedback}
                                    aria-label="feedback"
                                >
                                    Complete
                                </ActionButton1>
                            </Box>*/}
                        </Box>
                        {/* Centered play/pause button */}
            <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center" style={{ width: "100%", padding: "0 0 0 0" }}>
              <IconButton
                className={classes.iconButtonCenter}
                aria-label="play-pause"
                onClick={this.props.onPlayPauseClick}
              >
                {this.props.isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
              </IconButton>
            </Box>
                        {/* Bottom bar: progress and time */}
                        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between" style={{ width: "100%", padding: "clamp(4px, 0.4vw, 6px) clamp(4px, 0.4vw, 6px)", background: "linear-gradient(to bottom, rgba(247,249,252,0.55), #6a8caf)", borderRadius: 14, marginBottom: 0 }}>
              <StyledIconButton
                className={classes.styledIconResponsive}
                onClick={this.props.onPlayPauseClick}
                aria-label="play-pause"
              >
                {this.props.isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
              </StyledIconButton>
                            <Typography variant="body1" style={{ color: "#fff", marginLeft: 'clamp(4px, 0.5vw, 8px)', marginRight: 'clamp(4px, 0.5vw, 8px)', fontSize: 'clamp(11px, 1vw, 15px)' }}>
                                {this.format(this.state.playingData.playedSeconds)}
                            </Typography>
                            <Box style={{ flex: 1, margin: 0 }}>
                                <CustomizedProgressBars played={this.state.playingData.played} />
                            </Box>
              <StyledIconButton
                className={classes.styledIconResponsive}
                onClick={() => this.props.onFullScreen(status => !status)}
                aria-label="fullscreen-toggle"
              >
                {this.state.isFullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
              </StyledIconButton>
                        </Box>
                    </div>
            </div>

        );
    }
};



export default withStyles(styles)(VideoPlayer);
